import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TextFormControlComponent } from '@components/admin/configurator/forms/controls/text-form-control/text-form-control.component';
import { DefaultLayoutComponent } from '@layout/default-layout/default-layout.component';
import { ErrorDisplayMode } from '@models/interfaces/configuration/DynamicForm.interface';
import { AuthService } from '@services/auth.service';
import { ToastService } from '@services/toast.service';

@Component({
    selector: 'app-login',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        DefaultLayoutComponent,
        FormsModule,
        CommonModule,
        ReactiveFormsModule,
        TextFormControlComponent
    ],
    providers: [
        ToastService,
    ],
    templateUrl: './login.component.html',
    styleUrl: './login.component.css'
})
export class LoginComponent {
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);
  private readonly toast = inject(ToastService);

  protected readonly errorDisplayMode = ErrorDisplayMode;
  protected readonly form: FormGroup = new FormGroup({
    username: new FormControl('', [Validators.required, Validators.email]),
    password: new FormControl('', [Validators.required])
  });

  protected submit() {
    if (this.form.invalid) return;
    this.form.disable();
    this.authService.login(this.form.getRawValue()).subscribe({
      next: () => {
        if (this.authService.redirectUrl) {
          void this.router.navigateByUrl(this.authService.redirectUrl);
          return;
        }

        void this.router.navigate(['../../admin'], { relativeTo: this.route });
      },
      error: (err) => {
        this.toast.show(err.error.message || 'Login failed', 'error');
        this.form.enable();
      }
    });
  }
}
